module.exports = __webpack_public_path__ + "static/media/charts.99e17d08.jpg";